import React, { useCallback, memo } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import Squircle from 'design-system/Squircle';
import IconRepeat from 'design-system/icons/IconRepeat';
import BlurAmountView from 'design-system/BlurAmountView';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useStockMeta } from '../hooks';
import { formatNextBuyDate } from '../utils';
import useGetRealTimePrices from '../hooks/useGetRealTimePrices';
import { isWeb } from '../../../constants';
const RecurringBuyView = ({ recurringBuy }) => {
    const { assetId } = recurringBuy;
    const stockCache = useStockMeta(assetId);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    useGetRealTimePrices(assetId);
    const { navigateDeprecated } = useMainStackNavigation();
    const colors = useColors();
    const onPress = useCallback(() => {
        navigateDeprecated('RecurringBuy', { recurringBuy });
    }, [recurringBuy]);
    return (<TouchableHighlight hoverOnLight onCard={isWeb} underlayColor={colors.background.underlay} activeOpacity={1} onPress={onPress}>
      <View style={styles.container}>
        <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.mainContainer}>
          <Text Text-14 Secondary>
            BUY
          </Text>
          <View style={styles.row}>
            <View style={styles.flex}>
              <Text Text-16 numberOfLines={1}>
                {stockCache?.name || ''}
              </Text>
            </View>
            <Spacer w={8}/>
            <BlurAmountView enabled={scrambled}>
              <Text Numbers-16>{formatAmount(recurringBuy.amount.value, recurringBuy.amount.currency, 2)}</Text>
            </BlurAmountView>
          </View>

          <View style={styles.row}>
            <View style={styles.flex}>
              <View style={styles.row}>
                <Squircle height={rem(16)} width={rem(16)} color={colors.elements.secondary}>
                  <IconRepeat height={14} width={14} color={colors.cards.onDark}/>
                </Squircle>
                <Spacer w={8}/>
                <View style={styles.flex}>
                  <Text TextThin-14 Secondary>
                    Recurring
                  </Text>
                </View>
              </View>
            </View>
            <Spacer w={8}/>
            <Text TextThin-14 Secondary>
              {`Next on ${formatNextBuyDate(recurringBuy.nextBuy)}` || ''}
            </Text>
          </View>
        </View>
      </View>
    </TouchableHighlight>);
};
export default memo(RecurringBuyView);
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    mainContainer: {
        flex: 1,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
});
